/**
 * dateUtils.js - Semua operasi tanggal/waktu menggunakan WIB (UTC+7)
 *
 * Root cause bug UTC shift:
 * new Date("2026-04-25") → diparsing sebagai UTC midnight
 * Di WIB (+07:00) → menjadi 2026-04-24T17:00 (hari sebelumnya!)
 *
 * Solusi: selalu parse string tanggal sebagai local time dengan T00:00:00
 * atau gunakan string split langsung tanpa new Date()
 */

/** Ambil string "YYYY-MM-DD" dari nilai apapun yang datang dari API */
export function toDateStr(val) {
  if (!val) return '';
  if (typeof val === 'string') return val.slice(0, 10);
  if (val instanceof Date) return dateToStr(val);
  return String(val).slice(0, 10);
}

/** Konversi Date object ke "YYYY-MM-DD" menggunakan local time */
export function dateToStr(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth()+1).padStart(2,'0');
  const day = String(d.getDate()).padStart(2,'0');
  return `${y}-${m}-${day}`;
}

/** Hari ini dalam WIB sebagai string "YYYY-MM-DD" */
export function todayStr() {
  return dateToStr(new Date());
}

/**
 * Format tanggal ke display Indonesia: "25 April 2026"
 * WAJIB gunakan ini, jangan new Date(tanggalString) langsung
 */
export function formatTanggalID(val, opts = {}) {
  const str = toDateStr(val);
  if (!str) return '-';
  // Tambah T00:00:00 agar diparsing sebagai LOCAL time bukan UTC
  const d = new Date(str + 'T00:00:00');
  return d.toLocaleDateString('id-ID', { day:'numeric', month:'long', year:'numeric', ...opts });
}

/** Format { day: 25, month: "APR" } untuk date badge */
export function formatDateBadge(val) {
  const str = toDateStr(val);
  if (!str) return { day:'--', month:'---' };
  const d = new Date(str + 'T00:00:00');
  return {
    day: d.getDate(),
    month: d.toLocaleString('id-ID', { month:'short' }).toUpperCase(),
  };
}

/** Format jam dari "HH:MM:SS" menjadi "HH:MM" */
export function formatJam(jam) {
  if (!jam) return '--:--';
  return jam.slice(0, 5);
}

/** Jam WIB sekarang sebagai string "HH:MM" */
export function nowTimeStr() {
  const d = new Date();
  return `${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
}
